import { DataFlowColumn } from '../../../model/dataset/dataflowcolumn';

export class TransformationExpressionUtils {
    public static getUsedByColumns(column: DataFlowColumn, outputColumns: DataFlowColumn[]): string {
        // find reference in all columns
        return outputColumns.filter((v) =>
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            v.basedOnArguments.find((arg) => arg === column || (!(column instanceof DataFlowColumn) && arg.name === (column as any).name)))
            .map((v) => v.name).join(', ');
    }
}
